export default __webpack_public_path__ + "static/media/admin-ticket.4cbbe256.svg";